import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
  Grid,
  GridColumn as Column,
  GridSelectionChangeEvent,
  GridHeaderSelectionChangeEvent,
  getSelectedState,
  GridCellProps,
  GridNoRecords
} from '@progress/kendo-react-grid';
import { getter } from '@progress/kendo-react-common';
import { useEffect, useState } from 'react';
import { checkAvailability } from "../../utils/EllowUtils";
import { useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';


const DATA_ITEM_KEY: string = 'candidateId';
const SELECTED_FIELD: string = 'selected';
const idGetter = getter(DATA_ITEM_KEY);

const PositionTable = (props: any) => {


  // let products: { candidateId: string, allocatedTo: string }[] = props.data

  const [dataState, setDataState] = useState(props.data && props.data.map((dataItem: any) =>
    Object.assign({ selected: false }, dataItem)
  ));


  const [selectedState, setSelectedState] = React.useState<{
    [id: string]: boolean | number[];
  }>({});

  const [selectedCandidates, setSelectedCandidates] = useState<{ name: string, candidateId: string, company: string }[]>([]);

  useEffect(() => {
    setSelectedState(props.selectedState)
    setDataState(props.data && props.data.map((dataItem: any) =>
      Object.assign({ selected: false }, dataItem)
    ))

  }, [props.data])

  const onSelectionChange = React.useCallback(
    (event: GridSelectionChangeEvent) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });

      setSelectedState(newSelectedState);

      if (!event.dataItem.selected) {
        let selected = [...selectedCandidates, event.dataItem]
        setSelectedCandidates(selected)
        props.onSelection(selected)
      } else {
        const index = selectedCandidates.findIndex(item => item.candidateId === event.dataItem.candidateId);;
        if (index > -1) {
          selectedCandidates.splice(index, 1);
        }
        setSelectedCandidates(selectedCandidates)
        props.onSelection(selectedCandidates)
      }

    },
    [selectedState]
  );
  // const onSelectionChange = React.useCallback(
  //   (event: GridSelectionChangeEvent) => {
  //     const newSelectedState = getSelectedState({
  //       event,
  //       selectedState: selectedState,
  //       dataItemKey: DATA_ITEM_KEY
  //     });
  //     setSelectedState(newSelectedState);
  //   },
  //   [selectedState]
  // );

  const onHeaderSelectionChange = React.useCallback(
    (event: GridHeaderSelectionChangeEvent) => {
      const checkboxElement: any = event.syntheticEvent.target;
      const checked = checkboxElement.checked;
      const newSelectedState: any = {};
      

      event.dataItems.forEach((item: any) => {
        newSelectedState[idGetter(item)] = checked;
      })
      setSelectedState(newSelectedState);
      let candidates = []
      if (checked) {
        candidates = event.dataItems
      } else {
        candidates = []
      }
      props.onSelection(candidates)
    },
    []
  );
  // const onHeaderSelectionChange = React.useCallback(
  //   (event: GridHeaderSelectionChangeEvent) => {
  //     const checkboxElement: any = event.syntheticEvent.target;
  //     const checked = checkboxElement.checked;
  //     const newSelectedState: any = {}

  //     event.dataItems.forEach((item) => {
  //       newSelectedState[idGetter(item)] = checked;
  //     });
  //     setSelectedState(newSelectedState);
  //   },
  //   []
  // );

  //vishnu
  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const redirection = (candidateLoginId: string) => {
    localStorage.setItem('ResourcesCandidateLoginId', candidateLoginId);
    localStorage.setItem('ResourcesTab', '6');
    openInNewTab(`${window.location.origin}/createResources`)
  }

  return (
    <div className="tableStyle">
      <Grid
        data={dataState && dataState.map((item: any) => ({
          ...item,
          [SELECTED_FIELD]: selectedState[idGetter(item)],
        }))}
        style={{ height: '400px' }}
        dataItemKey={DATA_ITEM_KEY}
        selectedField={SELECTED_FIELD}
        selectable={{
          enabled: true,
          drag: false,
          cell: false,
          mode: 'multiple',
        }}
        onSelectionChange={onSelectionChange}
        onHeaderSelectionChange={onHeaderSelectionChange}
        onPageChange={props.pageChange}
        total={props.total}
        skip={props.state.skip}
        pageable={props.state.pageable}
        pageSize={props.state.pageSize}
        onItemChange={props.itemChange}
      >
        <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
        <Column
          field={SELECTED_FIELD}
          width="50px"
          headerSelectionValue={
            dataState && dataState.findIndex((item: any) => !selectedState[idGetter(item)]) === -1
          }
        />
        <Column field="name" title="Name" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string) => redirection(candidateLoginId))} />
        <Column field="email" title="Email" cell={emailCell} />
        <Column field="skills" title="Skills" cell={skillsCell} />
        <Column field="experience" title="Experience" cell={experienceCell} />
        <Column field="availability" title="Availability" cell={availablityCell} />
        <Column field="sourcedBy" title="Sourced By" cell={sourcedByCell} />
        <Column field="dateOfRegistration" title="Date of Registration" cell={dateCell}/>
        <Column field="certifications" title="Certification" cell={certificationsCell} />
        <Column field="ellowStatus" title="ellow Status" cell={ellowStatusCell} />
        <Column field="expectedpay" title="Expected Pay" cell={expectedPayCell}/>
        <Column field="allocatedTo" title="Allocated To" cell={allocatedToCell} />
      </Grid>
    </div>
  );
};

export default PositionTable;

const experienceCell = (props: GridCellProps) => {
  if (props.dataItem.experience !== null) {
    return <td>{props.dataItem.experience + " Years"}</td>;
  } else {
    return <td>{"Not Mentioned"}</td>;
  }
};

const availablityCell = (props: GridCellProps) => {

  let data = {
    availability: props.dataItem.availability,
    availability_date: props.dataItem.availability_date,
    availability_week: props.dataItem.availability_week
  }

  return <td>{checkAvailability(data)}</td>
}

const emailCell = (props: GridCellProps) => {

  return(
    <td className='wordBreak'>{props.dataItem.email}</td>
  )
}

const expectedPayCell = (props: GridCellProps) => {

  return(
    <td>{props.dataItem.rates !== null ? props.dataItem.rates +' '+ props.dataItem.currencyType + '/' + props.dataItem.billingType : 'Not Mentioned'}</td>
  )
}

const skillsCell = (props: GridCellProps) => {

  let length = props.dataItem.skills && props.dataItem.skills.length;

  return (
    <td >
      <div className="skillsWrap">
        {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number) => {
          return ((item) + (key < length - 1 ? ' , ' : ''))
        })}
      </div>
    </td>
  );
};

const dateCell = (props: GridCellProps) => {
  let dateNumber = parseInt(props.dataItem.dateOfRegistration);
  let date = new Date(dateNumber).toDateString();

  return <td><div className="dateWrap">{date}</div></td>;
};

const nameCell = (props: GridCellProps, redirection: any) => {

  const profileImage = props.dataItem.googleProfileImage ? props.dataItem.googleProfileImage : " "
    
  return (
    <td className="statusWrap">
      {props.dataItem.sourcedBy === 'Provider' &&
        <span className="userStatus">Provider</span>
      }
      <div className="userInfo" onClick={() => redirection(props.dataItem.loginId)}>
        {profileImage === " " ?
          <figure>{props.dataItem && props.dataItem.firstName && props.dataItem.firstName[0]}{props.dataItem && props.dataItem.lastName && props.dataItem.lastName[0]}</figure>
          :
          <figure><img src={profileImage}></img></figure>
        }
         <div>
          {props.dataItem.name}
        </div>
      </div>
    </td>
  )
}

//   return (
//     <td onClick={() => redirection(props.dataItem.loginId)} className="pointer">
//       {props.dataItem.name}
//     </td>
//   );
// };

const sourcedByCell = (props: GridCellProps) => {
  return (
    <td >
      {props.dataItem.sourcedBy}
    </td>
  );
};

const certificationsCell = (props: GridCellProps,) => {
  return (
    <td >
      {props.dataItem.certifications}
    </td>
  );
};
const ellowStatusCell = (props: GridCellProps,) => {
  return (
    <td >
      {props.dataItem.ellowStatus}
    </td>
  );
};
const allocatedToCell = (props: GridCellProps,) => {
  return (
    <td >
      {props.dataItem.allocatedTo}
    </td>
  );
};
